import styled from 'styled-components'

import { Text } from 'src/components/Ant'

type ConnectionsText = {
  connections: number
}

const StrongText = styled(Text).attrs(() => ({
  strong: true
}))`
  font-size: 18px;
`

const ConnectionsText = styled(StrongText)<ConnectionsText>`
  border-bottom: 2px solid
    ${({ connections }) => (connections ? '#fa8c16' : '#52c41a')};
  padding: 0 4px 4px 4px;
`

const SecondaryText = styled(Text).attrs(() => ({
  type: 'secondary'
}))`
  font-size: 12px;
`

export { ConnectionsText, SecondaryText, StrongText }
